import { useMutation } from "react-query";
import { ApplyData, studyCenterService } from "@services/study-center";

export const useApplyForEducationalEventMutation = () => {
  return useMutation((data: ApplyData) =>
    studyCenterService.applyForEvent(data)
  );
};
